import { graphql } from "~/gql";

export const FEE_EARNER_LEVELS_QUERY = graphql(/* GraphQL */ `
  query FindFeeEarnerLevels {
    feeEarnerLevels {
      records {
        id
        description
        externalReference
        order
        restrictedGpmVisible
      }
    }
  }
`);
